import React, { useEffect, useState } from 'react';
import { Modal } from '@zeeve-platform/modal-component';
import { Button } from '@zeeve-platform/button-component';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import ServerCard from './serverCard';
import Urls from '../../../utils/util';
import '../../../css/nodeLanding.css';
import NodeCard from './nodeCard';
import sync from '../../../images/sync.png';
import eye from '../../../images/eye.svg';
import eyeOff from '../../../images/eye-off.svg';
import polkadotLogo from '../../../images/Polkadot_Logo2.svg';
import appSubPath, { toCapitalize } from '../../../utils/helper';
import {
  getNetworkDetailData,
  getAllNodesData,
  deleteTheNetwork,
  getBlockHeightData,
  getAvailableCountData,
} from '../../../services/apisService';
import { NetworkType, RpcDetailType } from '../declaration';
import '../../../css/custom-responsive.css';
import '../../../css/custom.css';
import CloudInfo from '../../../utils/cloudInfo';
import Loading from '../../../components/common/loader';

interface Props {
  id: string | number;
  setType: React.Dispatch<React.SetStateAction<string>>;
}
type CodeSnippetType = 'CURL' | 'WSCAT' | 'NodeJs' | 'Python' | 'Go' | 'none';

const MyNetworkBody = ({ id, setType }: Props) => {
  const [networkData, setNetworkData] = useState<NetworkType[] | []>([]);
  const [rpcDetail, setRpcDetail] = useState({} as RpcDetailType);
  const [flag, setFlag] = useState(false);
  const [page, setPage] = useState('node');
  const [name, setName] = useState('My Network');
  const [networkPayment, setNetworkPayment] = useState(false);
  const [redirectionUrl, setRedirectionUrl] = useState('');
  const [nodeId, setNodeId] = useState<string>('');
  const [managedHosting, setManagedHosting] = useState<boolean>(false);
  const [networkStatus, setNetworkStatus] = useState<string>('');
  const [showKey, setShowKey] = useState<boolean>(false);
  const [sessionsKey, setSessionsKey] = useState<string>('');
  const [showLoader, setShowLoader] = useState(false);
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [isShow, setIShow] = useState<boolean>(true);
  const [deleteNetworkMsg, setDeleteNetworkMsg] = useState<string>('');
  const [hideEndpointSnippet, setHideEndpointSnippet] = useState<boolean>(false);
  const [codeSnippet, setCodeSnippet] = useState<CodeSnippetType>('CURL');
  const [codeType, setCodeType] = useState<'https' | 'wss'>('https');
  const [codes, setCodes] = useState<
    { lang: CodeSnippetType; http?: string; wss?: string }[]
  >([]);
  const [isModalFor, seIsModalFor] = useState<string>('');
  const [cloudId, setCloudId] = useState<string>('');

  /** get value of 'from' key to set breadcrumb path */
  const from = localStorage.getItem('from') || '';
  const path_url = localStorage.getItem('workspace_url') || '';

  /** returns breadcrumb path */
  const getBreadcrumbPart = (comingFrom: string) => {
    if (comingFrom === 'fullnode') {
      return { name: 'Dedicated Full Nodes', path: Urls.getAllNetworkUrl() };
    } if (comingFrom === 'workspace') {
      return { name: 'Workspaces', path: Urls.getWorkspaceUrl() };
    }
    return { name: 'Dedicated Validator Nodes', path: Urls.getStakingNetworksUrl() };
  };

  const paths = [
    { name: 'Dashboard', path: Urls.getDashboardUrl() },
    {
      name: getBreadcrumbPart(from).name,
      path: getBreadcrumbPart(from).path,
    },
  ];

  if (from === 'workspace') {
    paths.push({
      name: localStorage.getItem('workspaceName') as string,
      path: `${Urls.getWorkspaceUrl()}/${path_url}`,
    });
  }

  const zeeveManagedCloud: string = Urls.getZeeveManagedValue();

  function myFunction() {
    document.getElementById('my-dropdown')?.classList.toggle('show');
  }

  /* eslint-disable func-names */
  window.onclick = function (event) {
    const drop = document.getElementById('action-btn');
    if (event.target !== drop) {
      const dropdowns = document.getElementsByClassName('dropdown-content');
      let i;
      for (i = 0; i < dropdowns.length; i += 1) {
        const openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show');
        }
      }
    }
  };

  const displayModal = () => {
    if (networkData.some((data) => data.status === 'requested')) {
      seIsModalFor('DELETION_NOT_ALLOWED');
    } else {
      seIsModalFor('DELETE');
    }
    setModalShow(true);
  };

  const goToAddNode = async () => {
    if (await checkNodeAvailable()) {
      seIsModalFor('');
      setModalShow(false);
      window.location.href = appSubPath(`/nodes/full/${id}/add`);
    } else {
      seIsModalFor('AVAILABLE_COUNT');
      setModalShow(true);
    }
  };

  const checkNodeAvailable = async () => {
    const filterArr: string[] = [];
    const cloudName = CloudInfo.getCloudById(cloudId);
    if (managedHosting) {
      filterArr.push(zeeveManagedCloud);
    } else {
      filterArr.push(`BYOC-${cloudName}`);
    }
    if (filterArr && filterArr.length > 0) {
      setShowLoader(true);
      const responseData: any = await getAvailableCountData(filterArr);
      setShowLoader(false);
      if (responseData.success) {
        const cards = responseData.data;
        for (let i = 0; i < cards.length; i += 1) {
          if (cards[i].available_quantity > 0) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const getNetworkDetail = async () => {
    const response: any = await getNetworkDetailData(id);
    if (response && response.success) {
      // Call api for get all nodes list
      getAllNodes();
      if (response.data.networkNodeType === 'staking') {
        setHideEndpointSnippet(false);
        setType('staking');
      } else {
        setHideEndpointSnippet(true);
        setType('dedicated');
      }
      setNetworkPayment(response.data.status === 'payment_pending');
      setName(response.data.name);
      setRedirectionUrl(response.data.redirectionUrl);
      setManagedHosting(response.data.inputConfigurations.managedHosting);
      setCloudId(response.data.cloudId);
      setNetworkStatus(response.data.status);
    }
  };

  const checkNetworkStatus = (): boolean => {
    if (networkStatus === 'ready' || networkStatus === 'provisioning') {
      return true;
    }
    return false;
  };

  const getAllNodes = async () => {
    setShowLoader(true);
    const response: any = await getAllNodesData(id);
    setShowLoader(false);
    if (response && response.success) {
      setNetworkData(response.data);
    } else {
      setNetworkData([]);
    }
  };

  useEffect(() => {
    // Call api for get network details
    getNetworkDetail();
  }, []);

  const deleteNetwork = async (networkId: number | string) => {
    setShowLoader(true);
    const response: any = await deleteTheNetwork(networkId);
    setShowLoader(false);
    setIShow(false);
    if (response) {
      if (response.success) {
        setDeleteNetworkMsg(response.data.message);
        window.open(Urls.getDashboardUrl(), '_self');
      } else {
        setDeleteNetworkMsg(response.message);
      }
    } else {
      setDeleteNetworkMsg('Error deleting network');
    }
  };

  const setSelected = (num: number) => {
    for (let i = 1; i < 4; i += 1) {
      const spanSelected: HTMLBaseElement | null = document.querySelector(
        `#span${i}`,
      );
      const liSelected: HTMLBaseElement | null = document.querySelector(
        `#li${i}`,
      );
      if (i !== num) {
        if (
          spanSelected
          && liSelected
          && spanSelected.classList.contains('active-node')
        ) {
          spanSelected.classList.remove('active-node');
          liSelected.classList.remove('active-item');
        }
      } else if (
        i === num
        && spanSelected
        && !spanSelected.classList.contains('active-node')
      ) {
        spanSelected.classList.add('active-node');
        liSelected?.classList.add('active-item');
      }
    }
  };

  const setView = () => {
    if (page === 'node') {
      return (
        <NodeCard
          networkData={networkData}
          setRpcDetail={setRpcDetail}
          setFlag={setFlag}
          networkPayment={networkPayment}
          setNodeId={setNodeId}
          nodeID={nodeId}
          setSessionsKey={setSessionsKey}
          setCodes={setCodes}
          managedHosting={managedHosting}
        />
      );
    }
    return null;
  };
  const copyText = (val: string) => {
    const ptag: HTMLElement | null = document.getElementById('succ');
    const ptag2: HTMLElement | null = document.getElementById(val);

    if (ptag2) {
      let txt = '';
      if (val === 'key-tag') {
        txt = ptag2.getAttribute('value') || '';
      } else {
        txt = ptag2.textContent || '';
      }
      navigator.clipboard.writeText(txt);
      if (ptag) {
        ptag.style.display = 'block';
        setTimeout(() => {
          ptag.style.display = 'none';
        }, 1500);
      }
    }
  };

  const blockHeightCall = () => {
    if (flag) {
      getBlockHeight();
    }
  };

  const getBlockHeight = async () => {
    const blockHeightTag = document.getElementById('blockHeight');
    if (id) {
      setShowLoader(true);
      const response: any = await getBlockHeightData(
        id.toString(),
        nodeId.toString(),
      );
      setShowLoader(false);
      if (response) {
        if (response.success) {
          if (blockHeightTag) {
            blockHeightTag.innerHTML = response.data.blockHeight;
          }
        }
      }
    }
  };

  return (
    <section className="px-5 col-12">
      <img
        src={polkadotLogo}
        alt="polkadot-logo"
        className="mt-4"
        style={{ maxHeight: '32px' }}
      />
      <div className="row mt-4 align-items-center">
        <div className="col-lg-6 col-xl-6 col-sm-12 col-xs-12 cursor">
          <div className="d-flex">
            <Breadcrumb
              prefixLink={paths}
              activeLink={name}
              textSize={13}
              className="mt-1"
            >
              <span className="p-1 mx-1 all-color" style={{ fontSize: '13px' }}>
                {managedHosting ? ' - Zeeve Managed' : ' - BYOC'}
,
              </span>
              <span className="p-1  all-color" style={{ fontSize: '13px' }}>
                {networkData[0]?.inputs.nodeType
                  ? `${toCapitalize(networkData[0]?.inputs.nodeType)} Node`
                  : 'loading'}
                ,
              </span>
              <span className="p-1 mx-1 all-color" style={{ fontSize: '13px' }}>
                {networkData[0]?.inputs.network
                  ? `${toCapitalize(networkData[0]?.inputs.network)}`
                  : 'loading'}
                ,
              </span>
              <span className="p-1  all-color" style={{ fontSize: '13px' }}>
                {networkData[0]?.inputs.continentType
                  ? `${toCapitalize(networkData[0]?.inputs.continentType)}`
                  : 'loading'}
              </span>
            </Breadcrumb>
          </div>
        </div>
        <div className="col-lg-6 col-xl-6 col-sm-12 col-xs-12 button-add">
          <div className="d-flex justify-content-end">
            <div className="dropdown">
              {networkPayment && (
                <a
                  className="btn btn-primary"
                  style={{ textDecoration: 'none' }}
                  href={redirectionUrl}
                >
                  Pay Now
                </a>
              )}
              <Button
                type="button"
                onClick={() => {
                  myFunction();
                }}
                id="action-btn"
                className="ms-2 btn btn-primary"
                style={{ borderRadius: '10px' }}
                disabled={!(!networkPayment && checkNetworkStatus())}
              >
                Actions
              </Button>
              <div id="my-dropdown" className="dropdown-content">
                {hideEndpointSnippet && (
                  <li
                    style={{ cursor: 'pointer' }}
                    aria-hidden
                    onClick={goToAddNode}
                  >
                    Add Node
                  </li>
                )}
                <li
                  style={{ cursor: 'pointer' }}
                  onClick={displayModal}
                  aria-hidden
                >
                  Delete Network
                </li>
              </div>
            </div>
          </div>
        </div>
        {showLoader && <Loading />}
      </div>
      <div className="row justify-content-between mt-4">
        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-5">
          <div className="card">
            <nav className="navbar navbar-expand-lg navbar-light border-bottom">
              <div className="container-fluid">
                <div className="" id="navbarNav">
                  <ul className="Navbar nav container-equal-space">
                    <li
                      id="li1"
                      aria-hidden
                      className="nav-item active-item "
                      onClick={() => {
                        setPage('node');
                        setSelected(1);
                      }}
                    >
                      <span id="span1" className="nav-link active-node ">
                        Nodes
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
            <div>{setView()}</div>
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <ServerCard data={networkData} />
        </div>
      </div>
      <div
        id="succ"
        className="alert alert-success mt-5 text-center"
        style={{ display: 'none' }}
        role="alert"
      >
        Copied
      </div>
      <div className="row">
        {/* Node info section start */}
        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-5">
          <div className="card">
            <div
              className="m-4 border p-4"
              style={{ backgroundColor: '#F7F7F7', borderRadius: '10px' }}
            >
              <h6 className="mt-3 text-center">Node Info</h6>
              <div className="table-responsive mt-4 col-11 mb-2 p-2 mx-4">
                <table className="table table-bordered">
                  <tbody className="text-center">
                    <tr>
                      <td className="col-5 col-sm-5 pt-3">
                        <div>BlockHeight</div>
                      </td>
                      <td className="col-4 col-sm-4 pt-3">
                        <div>
                          <p id="blockHeight">0</p>
                        </div>
                      </td>
                      <td rowSpan={2} className="col-3 col-sm-3 pt-3">
                        <div>
                          <li
                            className="btnNodeli mx-5"
                            aria-hidden
                            style={{ border: '1px solid #D7DBE3' }}
                            title="refresh"
                            onClick={blockHeightCall}
                          >
                            <img
                              className="btnNode"
                              src={sync}
                              height="28px"
                              alt=""
                            />
                          </li>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {hideEndpointSnippet && (
                <div>
                  <h6 className="mt-3 pt-3 text-center">Endpoints</h6>
                  <p className="mt-3 text-muted">HTTP</p>
                  <div className="mt-1 mb-3 d-flex justify-content-between align-items-center px-3 py-2 rounded-2 mt-3 border bg-white cursor">
                    <p
                      id="http-ptag"
                      className="mb-0 text-muted"
                      style={{
                        wordBreak: 'break-all',
                      }}
                    >
                      Please select your node.
                    </p>
                    <i
                      className="fa fa-copy fs-6 text-primary"
                      aria-hidden
                      onClick={() => {
                        copyText('http-ptag');
                      }}
                    />
                  </div>
                  <p className="mt-3 text-muted">Web Socket</p>
                  <div className="mt-1 mb-3 d-flex justify-content-between align-items-center px-3 py-2 rounded-2 mt-3 border bg-white cursor">
                    <p
                      id="web-tag"
                      className="mb-0 text-muted"
                      style={{
                        wordBreak: 'break-all',
                      }}
                    >
                      Please select your node.
                    </p>
                    <i
                      className="fa fa-copy fs-6 text-primary"
                      aria-hidden
                      onClick={() => {
                        copyText('web-tag');
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Node info section end */}
        <div id="display" className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          {hideEndpointSnippet && (
            <div className="card">
              <div
                className="m-4 p-4 border"
                style={{ backgroundColor: '#F7F7F7', borderRadius: '10px' }}
              >
                <h6 className="mt-3 pt-1 text-center">
                  Example Connection Snippet
                </h6>
                <p className="text-end mt-4 mb-2">
                  <select
                    className="form-select"
                    defaultValue="Curl"
                    onChange={(event) => {
                      const selected = event.currentTarget
                        .value as CodeSnippetType;
                      if (selected === 'WSCAT') setCodeType('wss');
                      else setCodeType('https');
                      setCodeSnippet(selected);
                    }}
                  >
                    {codes.length === 0 && (
                      <option selected>Please select your node</option>
                    )}
                    {codes.map((code, index) => (
                      <option
                        key={`snippet-${index.toString()}`}
                        value={code.lang}
                      >
                        {code.lang}
                      </option>
                    ))}
                  </select>
                </p>
                <div className="card p-2 endpointcard rounded-2 bg-light">
                  <ul className="nav nav-tabs " id="myTab" role="tablist">
                    <li
                      className="nav-item"
                      role="presentation"
                      style={{
                        display: codeSnippet === 'WSCAT' ? 'none' : 'block',
                      }}
                      onClick={() => setCodeType('https')}
                    >
                      <button
                        className={`nav-link px-4 ${
                          codeType === 'https' ? 'active' : ''
                        }`}
                        data-bs-toggle="tab"
                        type="button"
                        role="tab"
                      >
                        <span className="p-1">HTTP</span>
                      </button>
                    </li>
                    <li
                      className="nav-item"
                      role="presentation"
                      style={{
                        display: codeSnippet === 'CURL' ? 'none' : 'block',
                      }}
                      onClick={() => setCodeType('wss')}
                    >
                      <button
                        className={`nav-link px-4 ${
                          codeType === 'wss' ? 'active' : ''
                        }`}
                        data-bs-toggle="tab"
                        type="button"
                        role="tab"
                      >
                        <span className="p-1">WS</span>
                      </button>
                    </li>
                  </ul>
                  <div className="d-flex justify-content-between gap-2">
                    <div className="p-2" />
                    <div className="snippet">
                      <div className="d-flex justify-content-end px-2">
                        <span>
                          <i
                            aria-hidden
                            className="fa fa-copy fs-6 text-primary p-2 cursor"
                            onClick={() => {
                              copyText('codesnippet');
                            }}
                          />
                        </span>
                      </div>
                      <pre style={{ whiteSpace: 'pre-wrap' }}>
                        <code id="codesnippet" className="">
                          {codes.length === 0 && <>Please select your node</>}
                          {codes.length > 0
                            && codeType === 'https'
                            && (codes.find((code) => codeSnippet === code.lang)
                              ?.http || <>HTTP endpoint is not available!</>)}

                          {codes.length > 0
                            && codeType === 'wss'
                            && (codes.find((code) => codeSnippet === code.lang)
                              ?.wss || (
                              <>WebSocket endpoint is not available!</>
                            ))}
                        </code>
                      </pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {flag && sessionsKey && (
        <div
          className="row mb-5 mt-5 col-12"
          style={{
            border: '2px solid #D7DBE3',
            borderRadius: '15px',
          }}
        >
          <h6 className="text-center mt-2">Sessions Key</h6>
          <div className="col-12 text-end">
            <i
              className="fa fa-copy mx-2"
              aria-hidden
              onClick={() => {
                copyText('key-tag');
              }}
              style={{ fontSize: '20px', color: '#4A82EB' }}
            />
          </div>
          <div className="col-12 mt-1 px-3">
            <div className="input-group mb-3 inputGroup" id="forgePass">
              <input
                type={showKey ? 'text' : 'password'}
                id="key-tag"
                className="form-control"
                defaultValue={sessionsKey}
                disabled
              />
              <span
                className="input-group-text"
                aria-hidden
                onClick={() => {
                  setShowKey(!showKey);
                }}
              >
                <img
                  id="forgePassImg"
                  src={showKey ? eye : eyeOff}
                  alt="eye-icon"
                />
              </span>
            </div>
          </div>
        </div>
      )}
      <Modal
        show={modalShow}
        onHide={() => {
          setDeleteNetworkMsg('');
          seIsModalFor('');
          setModalShow(false);
          setIShow(true);
        }}
        title={
          isModalFor === 'DELETE'
            ? `Are you sure you want to delete ${name} Network ?`
            : ''
        }
        visibleFooter
        visibleFooterCloseButton
        visibleHeaderCloseIcon={false}
        visibleConfirmBtn={isModalFor === 'DELETE' && isShow}
        confirmBtnText="Yes"
        onConfirm={() => deleteNetwork(id)}
        confirmBtnClassName=""
      >
        {isModalFor === 'DELETE' && (
          <p className="status text-center pt-3">{deleteNetworkMsg}</p>
        )}
        {isModalFor === 'AVAILABLE_COUNT' && (
          <div className="text-center p-3">
            Do not have sufficient Nodes to deploy.
            {' '}
            <a
              href={Urls.getMarketplaceUrl()}
              className="text-primary cursor text-decoration-underline"
            >
              Update your Subscription
            </a>
          </div>
        )}
        {isModalFor === 'DELETION_NOT_ALLOWED' && (
          <div className="alert alert-danger text-center mt-3" role="alert">
            <h6 className="ms-1 mb-0 col-12">
              Network cannot be deleted right now as at least one of the node is
              still not in provisioning or ready state.
            </h6>
          </div>
        )}
      </Modal>
    </section>
  );
};

export default MyNetworkBody;
